import { OrgNode } from '../orgs/interfaces';
import logger from '../../util/logger';

export function formatOrgData(org: OrgNode, payableOrg: OrgNode): OrgNode {
  const formattedOrg = {
    ...org,
    name: payableOrg.name,
    fields: payableOrg.fields,
  };
  logger('Formatted org object', false, formattedOrg);
  return formattedOrg;
}
